<div class="wg-wizard-dialog">

  <!-- Left: Step sidebar -->
  <div class="wg-wizard-sidebar">

    <!-- Header -->
    <div class="wg-wizard-sidebar-header">
      <h2>{{createNewView ? translate('galis_js_SearchForm_CreateNewView') : translate('galis_js_SearchForm_ViewSettingsLabel')}}</h2>
      <p>{{translate('galis_js_SearchForm_PogledLabel')}}</p>
    </div>

    <!-- Steps -->
    <div class="wg-wizard-sidebar-steps">
      @for (step of visibleSteps; track step.key; let i = $index) {
        <button class="wg-wizard-step" [ngClass]="{'wg-wizard-step-active': i === currentStep, 'wg-wizard-step-completed': i < currentStep}" (click)="goToStep(i)">
          <div class="wg-wizard-step-number">
            @if (i < currentStep) {
              <span class="wg-wizard-check">&#10003;</span>
            } @else {
              {{ i + 1 }}
            }
          </div>
          <div class="wg-wizard-step-text">
            <div class="wg-wizard-step-title">{{ step.title }}</div>
            <div class="wg-wizard-step-subtitle">{{ step.subtitle }}</div>
            @if (step.optional) {
              <div class="wg-wizard-step-optional">NEOBVEZNO</div>
            }
          </div>
        </button>
      }
    </div>

    <!-- Progress -->
    <div class="wg-wizard-sidebar-progress">
      <div class="wg-wizard-progress-text">
        <span>Korak {{ currentStep + 1 }} od {{ visibleSteps.length }}</span>
        <span>{{ progressPercent }}%</span>
      </div>
      <div class="wg-wizard-progress-bar">
        <div class="wg-wizard-progress-fill" [style.width.%]="progressPercent"></div>
      </div>
    </div>
  </div>

  <!-- Right: Content area -->
  <div class="wg-wizard-content">

    <!-- Content header -->
    <div class="wg-wizard-content-header">
      <div>
        <h3>{{ currentStepData.title }}</h3>
        <p>{{ currentStepData.subtitle }}</p>
      </div>
      <button class="wg-wizard-close-btn" (click)="closeDialog()">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <!-- Content body -->
    <div class="wg-wizard-content-body">

      <!-- STEP: Osnovno (Basic) -->
      @if (currentStepData.key === 'basic') {
        <div class="wg-wizard-form">
          <div class="wg-wizard-form-group">
            <label class="wg-wizard-label">{{translate('galis_js_SearchForm_SearchViewNameLabel')}}</label>
            <sem-text-box [isPasswordInput]="false" [isNumberInput]="false" class="wg-wizard-input" [(ngModel)]="viewLabel" name="view-label-value" />
          </div>
          <div class="wg-wizard-form-group">
            <label class="wg-wizard-label">{{translate('galis_js_SearchForm_PlaceholderLabel')}}</label>
            <sem-text-box [isPasswordInput]="false" [isNumberInput]="false" class="wg-wizard-input" [(ngModel)]="placeHolderTitle" name="placeholder-view-value" />
          </div>
          @if (userIsAdmin) {
            <div class="wg-wizard-form-group">
              <label class="wg-wizard-label">{{translate('galis_js_SearchForm_GlobalViewCheckbox')}}</label>
              <sem-check-box [showLabel]="false" [isReadOnly]="!createNewView" class="wg-wizard-input" [(ngModel)]="globalView" name="globalView-view-value"></sem-check-box>
            </div>
          }
        </div>
      }

      <!-- STEP: Iskalna polja (Search fields) -->
      @if (currentStepData.key === 'search') {
        <div class="drag-drop-content">
          <div class="left-container">
            <div class="wg-panel-header">
              <label class="wg-wizard-label">RAZPOLOŽLJIVA POLJA</label>
              <span class="wg-field-count">{{ availibleSearchFields.length }}</span>
            </div>
            <div class="wg-search-input-wrapper">
              <span class="material-symbols-outlined">search</span>
              <input type="text" placeholder="Poišči polje..."
                (input)="searchFieldSearch($event.target.value)" />
            </div>
            <div class="all-search-fields">
              <ul>
                <ng-scrollbar [visibility]="'hover'">
                  @for (item of availibleSearchFields; track item) {
                    <li [ngClass]="{'active': selectedSearchItem == item}" (click)="searchListItemClick($event, item)"
                      (dblclick)="doubleClickSearchFieldAdd($event, item)"
                      [matTooltip]="item.Translation" [matTooltipPosition]="'left'" matTooltipClass="searchproperty-tooltip">
                      {{ item.Translation }}
                    </li>
                  }
                </ng-scrollbar>
              </ul>
            </div>
          </div>
          <div class="action-buttons">
            <button class="wg-action-btn" (click)="addSearchField()">
              <span class="material-symbols-outlined">chevron_right</span>
            </button>
            <button class="wg-action-btn" (click)="removeAddedSearchField()">
              <span class="material-symbols-outlined">chevron_left</span>
            </button>
          </div>
          <div class="right-container">
            <div class="wg-panel-header">
              <label class="wg-wizard-label">IZBRANA ISKALNA POLJA</label>
              <span class="wg-field-count">{{ addedSearchFields.length }}</span>
            </div>
            <div class="added-search-fields" cdkDropList (cdkDropListDropped)="dropSearchField($event)">
              @if (addedSearchFields.length === 0) {
                <div class="wg-empty-state">
                  <span class="material-symbols-outlined">add</span>
                  <p>Dodajte iskalna polja</p>
                </div>
              }
              <ul>
                <ng-scrollbar [visibility]="'hover'">
                  @for (item of addedSearchFields; track item) {
                    <li [ngClass]="{'active': selectedSearchItem == item}" (click)="searchListItemClick($event, item)"
                      (dblclick)="doubleClickSearchFieldRemove($event, item)" cdkDrag
                      [matTooltip]="item.Translation" [matTooltipPosition]="'right'" matTooltipClass="searchproperty-tooltip">
                      {{ item.Translation }}
                    </li>
                  }
                </ng-scrollbar>
              </ul>
            </div>
          </div>
        </div>
      }

      <!-- STEP: Prikazna polja (Display fields) -->
      @if (currentStepData.key === 'display') {
        <div class="drag-drop-content">
          <div class="left-container">
            <div class="wg-panel-header">
              <label class="wg-wizard-label">RAZPOLOŽLJIVA POLJA</label>
              <span class="wg-field-count">{{ availibleDisplayFields.length }}</span>
            </div>
            <div class="wg-search-input-wrapper">
              <span class="material-symbols-outlined">search</span>
              <input type="text" placeholder="Poišči polje..."
                (input)="displayFieldSearch($event.target.value)" />
            </div>
            <div class="all-search-fields">
              <ul>
                <ng-scrollbar [visibility]="'hover'">
                  @for (item of availibleDisplayFields; track item) {
                    <li [ngClass]="{'active': selectedDisplayItem == item}" (click)="displayListItemClick($event, item)"
                      (dblclick)="doubleClickDisplayFieldAdd($event, item)"
                      [matTooltip]="item.Translation" [matTooltipPosition]="'left'" matTooltipClass="searchproperty-tooltip">
                      {{ item.Translation }}
                    </li>
                  }
                </ng-scrollbar>
              </ul>
            </div>
          </div>
          <div class="action-buttons">
            <button class="wg-action-btn" (click)="addDisplayField()">
              <span class="material-symbols-outlined">chevron_right</span>
            </button>
            <button class="wg-action-btn" (click)="removeAddedDisplayField()">
              <span class="material-symbols-outlined">chevron_left</span>
            </button>
          </div>
          <div class="right-container">
            <div class="wg-panel-header">
              <label class="wg-wizard-label">IZBRANA PRIKAZNA POLJA</label>
              <span class="wg-field-count">{{ addedDisplayFields.length }}</span>
            </div>
            <div class="added-search-fields" cdkDropList (cdkDropListDropped)="dropDisplayField($event)">
              @if (addedDisplayFields.length === 0) {
                <div class="wg-empty-state">
                  <span class="material-symbols-outlined">add</span>
                  <p>Dodajte prikazna polja</p>
                </div>
              }
              <ul>
                <ng-scrollbar [visibility]="'hover'">
                  @for (item of addedDisplayFields; track item) {
                    <li [ngClass]="{'active': selectedDisplayItem == item}" (click)="displayListItemClick($event, item)"
                      (dblclick)="doubleClickDisplayRemove($event, item)" cdkDrag
                      [matTooltip]="item.Translation" [matTooltipPosition]="'right'" matTooltipClass="searchproperty-tooltip">
                      {{ item.Translation }}
                    </li>
                  }
                </ng-scrollbar>
              </ul>
            </div>
          </div>
        </div>
      }

      <!-- STEP: Filtri (Filters) -->
      @if (currentStepData.key === 'filters') {
        <div class="query-builder-view-settings">
          <query-builder class="sem-query-builder" [(ngModel)]="queryBuilderModel" [emptyMessage]="'WebGalis_QueryBuilder_EmptyRuleGroupMessage'" [config]="queryBConfig"></query-builder>
        </div>
      }

      <!-- STEP: Sortiranje (Sorting) -->
      @if (currentStepData.key === 'sorting') {
        <div class="sort-view-settings">
          <div class="wg-sort-header">
            <p class="wg-sort-description">Privzeto razvrščanje rezultatov v tem pogledu.</p>
            <button class="wg-wizard-add-sort-link" (click)="addSortField()">
              <span class="material-symbols-outlined">add</span>
              Dodaj razvrščanje
            </button>
          </div>
          @for (sortField of selectedSortFields; track sortField; let i = $index) {
            <div class="wg-sort-row">
              <span class="wg-sort-row-number">{{ i + 1 }}</span>
              <mat-form-field class="wg-sort-field-select">
                <mat-select [(value)]="sortField.Name" (selectionChange)="onSortFieldChange(i, $event)">
                  @for (field of availibleSortFields; track field) {
                    <mat-option [value]="field.Name">
                      {{ field.Translation }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="wg-sort-order-select">
                <mat-select [(value)]="sortField.order" (selectionChange)="sortOrderChange(i, $event)">
                  <mat-option value="asc">{{translate('galis_js_GridData_Ascending')}}</mat-option>
                  <mat-option value="desc">{{translate('galis_js_GridData_Descending')}}</mat-option>
                </mat-select>
              </mat-form-field>
              <button class="sorting-tab-icon-close" (click)="removeSortField(i)">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
          }
        </div>
      }

      <!-- STEP: Glavni meni (Main menu) -->
      @if (currentStepData.key === 'menu') {
        <div class="leftmenu-view-settings left-menu-nodes-settings">
          <p class="wg-wizard-menu-intro">Pogled lahko dodate tudi v glavni meni aplikacije</p>
          <div class="wg-wizard-form">
            <div class="wg-wizard-form-group">
              <label class="wg-wizard-label">Pogled želim dodati v glavni meni (1. nivo)</label>
              <sem-check-box [showLabel]="false" class="wg-wizard-input" [(ngModel)]="addOnLeftMenuRoot" (ngModelChange)="onCheckboxChange($event)" name="globalView-view-value"></sem-check-box>
            </div>
            <div class="wg-wizard-form-group">
              <label class="wg-wizard-label">Izberite pod kateri podmeni želite dodati dostop do pogleda:</label>
              <mat-form-field class="wg-wizard-select" [ngClass]="{'disabled-select': addOnLeftMenuRoot}">
                <mat-select [(value)]="leftMenuNode" [disabled]="addOnLeftMenuRoot" (selectionChange)="onLeftMenuNodeChange($event)">
                  @for (node of leftMenuNodes; track node) {
                    <mat-option [value]="node">
                      {{ node.Title }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="wg-wizard-form-group">
              <label class="wg-wizard-label">Vrstni red v meniju</label>
              <input type="number" [(ngModel)]="leftMenuNodeOrder" name="left-menu-order-value" class="wg-wizard-number-input" />
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Error message -->
    @if (validationErrorMessage.length > 0) {
      <div class="wg-wizard-error">
        <span class="material-symbols-outlined">error</span>
        <p>{{validationErrorMessage}}</p>
      </div>
    }

    <!-- Footer: navigation -->
    <div class="wg-wizard-content-footer">
      @if (currentSettingId > 0 && createNewView == false && onlyGridSettings === false) {
        <button class="wg-wizard-btn-delete" (click)="deleteView()">
          <span class="material-symbols-outlined">delete</span>
          {{translate('galis_js_SearchForm_DeleteView')}}
        </button>
      }

      <div class="wg-wizard-footer-spacer"></div>

      @if (currentStep > 0) {
        <button class="wg-wizard-btn-back" (click)="prevStep()">
          <span class="material-symbols-outlined">chevron_left</span>
          Nazaj
        </button>
      }

      @if (isLastStep) {
        <button class="wg-wizard-btn-save" (click)="saveUpdateViewSettings()">
          {{translate('galis_js_SearchForm_SaveButton')}}
          <span class="material-symbols-outlined">check</span>
        </button>
      } @else {
        @if (createNewView === false) {
          <button class="wg-wizard-btn-save" (click)="saveUpdateViewSettings()">
            {{translate('galis_js_SearchForm_SaveButton')}}
            <span class="material-symbols-outlined">check</span>
          </button>
        }
        <button class="wg-wizard-btn-next" (click)="nextStep()">
          Naprej
          <span class="material-symbols-outlined">chevron_right</span>
        </button>
      }
    </div>
  </div>
</div>
